import { render, staticRenderFns } from "./Motivation.vue?vue&type=template&id=c4e50410&scoped=true&"
import script from "./Motivation.vue?vue&type=script&lang=ts&"
export * from "./Motivation.vue?vue&type=script&lang=ts&"
import style0 from "./Motivation.vue?vue&type=style&index=0&id=c4e50410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e50410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c4e50410', component.options)
    } else {
      api.reload('c4e50410', component.options)
    }
    module.hot.accept("./Motivation.vue?vue&type=template&id=c4e50410&scoped=true&", function () {
      api.rerender('c4e50410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/Motivation.vue"
export default component.exports